const themeConst = {
  light: 'light',
  dark: 'dark',
}

export { themeConst }
